import React, { Component } from 'react';
import Slider from 'react-slick';
import SchemeSvg from 'Root/solutions-infohub/components/scheme-svg';
import '../global';

class SolutionsTabs extends Component {
	constructor() {
		super();
		const sliderInfo = getSolutionsInfohubSliders();

		const tabs = sliderInfo.map( ( slider, index ) => {
			return {
				id   : index + 1,
				name : slider.slider_title,
				items: slider.slider_items.map( ( item, index ) => {
					return {
						id         : index,
						name       : item.item_title,
						description: item.item_description,
						image      : item.item_image_url,
						link       : item.item_learn_more_link,
						activeImage: item.item_image_url_active || item.item_image_url,
					};
				} ),
			};
		} );

		this.state = {
			activeTab: 1,
			currentSlide1: 1,
			currentSlide2: 1,
			currentSlide3: 1,
			tabs
		};
	}

	checkParentClass(element) {
		if (element && element.parentElement) {
			// Traverse up to find solutions__tab-slide
			let slideElement = element;
			while (slideElement && !slideElement.classList.contains('solutions__tab-slide')) {
				slideElement = slideElement.parentElement;
			}
	
			// If the slide has 'default' class, use different logic
			if (slideElement && slideElement.classList.contains('default')) {
				return true; // Always return true for default slides
			}
	
			// Find the slick-slide parent
			let slickSlideElement = slideElement;
			while (slickSlideElement && !slickSlideElement.classList.contains('slick-slide')) {
				slickSlideElement = slickSlideElement.parentElement;
			}
	
			if (slickSlideElement) {
				// Check if we're in mobile view (less than 1200px)
				const isMobileView = window.innerWidth < 1200;
	
				if (isMobileView) {
					// Mobile view: check if this is the current slide
					return slickSlideElement.classList.contains('slick-current');
				} else {
					// Desktop view: check if this is active slide after current
					const isActive = slickSlideElement.classList.contains('slick-active');
					const previousSibling = slickSlideElement.previousElementSibling;
					const isPreviousCurrent = previousSibling && previousSibling.classList.contains('slick-current');
	
					return isActive && isPreviousCurrent;
				}
			}
		}
		return false;
	}

	// This method handles tab switching
	switchTab( index ) {
		this.setState( { activeTab: index } );
	};

	render() {
		const { activeTab, tabs } = this.state;
		const settings = {
			className: "center",
			swipeToSlide: true,
			dots: true,
			infinite: true,
			speed: 500,
			prevArrow     : <button type="button" className="slick-prev"><i className="fa-solid fa-chevron-left"></i></button>,
			nextArrow     : <button type="button" className="slick-next"><i className="fa-solid fa-chevron-right"></i></button>,
			beforeChange: (prev, next) => {
				const adjustedNext = next + 1;
				this.setState({ [`currentSlide${activeTab}`]: adjustedNext });
			},
			responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 1,
				}
			}],
		};

		const activeSlide = this.state[`currentSlide${activeTab}`]


		return (<div>
				{/* Tab headers */ }
				<ul className="solutions__tab-controls">
					{ tabs.map( ( tab ) => (<li
							className={ activeTab === tab.id ? 'active' : '' }
							onClick={ () => this.switchTab( tab.id ) }
						>
							{ tab.name }
						</li>
					) ) }
				</ul>

				{/* Tab content */ }
				
				<div className="solutions__tabs">
					{tabs.map((tab) => <div className={`solutions__tab ${activeTab === tab.id ? "active" : ''}`}>
						<Slider slidesToShow={activeTab === 3 ? 2 : 3}
						        {...settings}
						>
							{ tab.items.map( (item, index) => <div className={`solutions__tab-slide ${activeTab === 3 ? 'default' : ''}`}>
								<div className={"solutions__tab-data"}>
									<a href={item.link}>
										<div className={ 'image-block' }>
											<img
												src={ `${ window.location.origin }/wp-content/themes/isda-theme-underscores/images/solutions-infohub/Bg_inactive.png` }
												alt="digital solution background"
											/>
											<img
												className={ `activeState ${ activeSlide === index || (index === 0 && activeSlide === tab.items.length
												) ? 'visible' : '' }` }
												src={ `${ window.location.origin }/wp-content/themes/isda-theme-underscores/images/solutions-infohub/Bg_active.png` }
												alt="digital solution background"
											/>
											<img
												className={'solution-logo'}
												src={ `${ item.image }` }
												alt="digital solution background"
											/>
										</div>
									</a>

									<div className={ 'd-flex' }>
										<b>0{ item.id === 0
										      ? tab.items.length
										      : item.id }</b><span>/</span>0{ tab.items.length }
									</div>
								</div>

								<h2>
									<a href={ item.link }><span>{ item.name }</span></a>
								</h2>
								<div className="solutions__tab-divider"></div>
								<p>{ item.description }</p>
								<a href={ item.link } className="read-more">
									Learn more
									<svg width="28" height="16"
									     viewBox="0 0 28 16"
									                fill="none"
									                xmlns="http://www.w3.org/2000/svg">
									<path
										d="M1 7C0.447715 7 4.82823e-08 7.44772 0 8C-4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM27.7071 8.70711C28.0976 8.31658 28.0976 7.68342 27.7071 7.2929L21.3431 0.928934C20.9526 0.53841 20.3195 0.538409 19.9289 0.928934C19.5384 1.31946 19.5384 1.95262 19.9289 2.34315L25.5858 8L19.9289 13.6569C19.5384 14.0474 19.5384 14.6805 19.9289 15.0711C20.3195 15.4616 20.9526 15.4616 21.3431 15.0711L27.7071 8.70711ZM1 9L27 9L27 7L1 7L1 9Z"
										fill="#C6A57D"/>
								</svg>
								</a>
							</div> ) }
						</Slider>
					</div> ) }
				</div>
			</div>
		);
	}
}

export default SolutionsTabs;